package ui.enums

import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.StringResource
import thewedding_cmp.composeapp.generated.resources.Res
import thewedding_cmp.composeapp.generated.resources.appBarTitleConstruction
import thewedding_cmp.composeapp.generated.resources.appBarTitleFactsHistory
import thewedding_cmp.composeapp.generated.resources.appBarTitleLocation
import thewedding_cmp.composeapp.generated.resources.gallery
import thewedding_cmp.composeapp.generated.resources.gift
import thewedding_cmp.composeapp.generated.resources.pin_wedding

enum class InfoSection(val title: StringResource, val imageDrawable: DrawableResource) {
    Gallery(Res.string.appBarTitleFactsHistory, Res.drawable.gallery),
    WeddingInfo(Res.string.appBarTitleLocation, Res.drawable.pin_wedding),
    GiftAndWish(Res.string.appBarTitleConstruction, Res.drawable.gift)
}